import { useEffect } from "react";
import { BrowserRouter } from "react-router-dom";
import ReactDOM from "react-dom";
import { I18nextProvider } from "react-i18next";
import { HelmetProvider } from "react-helmet-async";
import "antd/dist/antd.css";
import "leaflet/dist/leaflet.css";
import ReactGA from "react-ga4";
import Router from "./router";
import i18n from "./translation";

const GA_MEASUREMENT_ID = "G-JQ3ZDFP50T";
const App = () => {
  useEffect(() => {
    ReactGA.initialize(GA_MEASUREMENT_ID);
  }, []);
  return (
    <HelmetProvider>
      <BrowserRouter>
        <I18nextProvider i18n={i18n}>
          <Router />
        </I18nextProvider>
      </BrowserRouter>
    </HelmetProvider>
  );
};

ReactDOM.render(<App />, document.getElementById("root"));
